import {BreadCrumbs} from "../../../components/open/pages";
import {useEffect, useState} from "react";
import {AuthRedirectParents, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading} from "../../../components/template/architecture";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {Link} from "react-router-dom";
import {ThinAddIcon, ThinArrowLeft, ThinChatIcon, ThinChatUnreadIcon} from "../../../components/icons/material-icons";
import {StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GregorianToPersian} from "../../../components/techaran/date-convert";
import {StudentsCreateTicketModal} from "./create-ticket";

interface ticketInterface {
    nd: string,
    title: string,
    createdAt: string,
    isClosed: 0 | 1,
    closedAt: string,
}

export const StudentsTicketsScreen = () => {
    const [list, setList] = useState<ticketInterface[]>([]);
    const [loaded, setLoaded] = useState(false);
    const fetchList = () => {
        PostJSON(
            Apis.server + '/core/parents/tickets/list',
            {},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: ticketInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectParents();
                    return;
                }
                setList(d.list === null ? [] : d.list);
                setLoaded(true);
            },
            () => {
                ShowConnectionFailed('fa');
                HideProgressLoading();
            },
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "تیکت‌ها | نهال";
        fetchList();
    }, []);
    const [createModal, setCreateModal] = useState(false);
    return (
        <>
            <BreadCrumbs links={[
                {title: 'پنل دانش‌آموزان', url: '/students/'},
                {title: 'تیکت‌ها', url: '/students/tickets'},
            ]}/>
            {
                loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>تیکت‌ها</b>
                                <button onClick={() => setCreateModal(true)}>
                                    <ThinAddIcon/>
                                    <span>تیکت جدید</span>
                                </button>
                            </div>
                            {
                                list.length < 1 ?
                                    <div className="staff--not-found">
                                        <em style={{backgroundImage: 'url(/svg/ticket.svg)'}}/>
                                        <b>تیکتی یافت نشد</b>
                                        <p>شما تاکنون درخواست پشتیبانی صادر نکرده‌اید.</p>
                                    </div> : list.map((t, i) =>
                                        <Link to={`/students/tickets/view/${t.nd}`}
                                              key={"J39fFk39Dks22l3" + i}
                                              className={'ticket-item' + (t.isClosed === 0 ? ' ticket-item-closed' : '')}>
                                            <div>
                                                <i>{t.isClosed === 0 ? <ThinChatUnreadIcon/> : <ThinChatIcon/>}</i>
                                                <div>
                                                    <b className={"max-lines-1"}>{t.title}</b>
                                                    <span>تاریخ {StringDigitsConvertToPersian(GregorianToPersian(t.createdAt).replaceAll('-', '/'))} - {t.isClosed === 1 ? 'بسته شده' : 'در انتظار پاسخ'}</span>
                                                </div>
                                            </div>
                                            <ThinArrowLeft/>
                                        </Link>
                                    )
                            }
                        </div>
                    </div> : null
            }
            <StudentsCreateTicketModal
                active={createModal}
                closeHandler={() => setCreateModal(false)}
            />
        </>
    );
};